/** "Type: <name>", the type the picked files will be added as; nothing when there's no type. */
export const FileTypeName = ({ fileTypeName }: { fileTypeName: string | undefined }) => {
    if (!fileTypeName) {
        return null;
    }

    return (
        <div>
            Type: <b>{fileTypeName}</b>
        </div>
    );
};
